import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderService } from '../shared/services/loader.service';

@Component({
  selector: 'rqa-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loaderService.loading$ | async) {
      <div class="loading-overlay">
        <div class="loader-container">
          <div class="loader"></div>
          <span>Ładowanie danych...</span>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    .loading-overlay {
        position: fixed;
        inset: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(15, 23, 42, 0.45);
        backdrop-filter: blur(4px);
        z-index: 9999;
    }

    .loader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding: 32px;
        min-width: 200px;
        border-radius: 16px;
        background: white;

        box-shadow:
            0 8px 32px rgba(0, 0, 0, 0.18),
            0 0 0 1px rgba(255,255,255,0.15);
        }

    .loader {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        border: 4px solid #e2e8f0;
        border-top-color: #2563eb;
        animation: spin 1s linear infinite;
    }

    .loader-container span {
        font-size: 14px;
        color: #334155;
        font-weight: 500;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
  `
})
export class LoaderComponent {
  loaderService = inject(LoaderService);
}
